import { CCol, CRow } from '@coreui/react-pro'
import React from 'react'
import PropTypes from 'prop-types'
import { dateUSFormat } from '../../../utils/dateTimeUtils'

const DashboardHeader = ({ providerName }) => {
  return (
    <div className="dash-header">
      <CRow>
        <CCol sm="9">
          <h1 className="title-name">
            Welcome{' '}
            {!providerName?.title ? (
              <span className="name">
                {providerName?.first_name} {providerName?.last_name}
              </span>
            ) : (
              <span className="name">
                {providerName?.first_name} {providerName?.last_name}
                {','} {providerName?.title}
              </span>
            )}
          </h1>
        </CCol>
        <CCol sm="3">
          <h1 className="title-name">
            <small className="title-description">
              Today is {dateUSFormat(new Date().toISOString())}
            </small>
          </h1>
        </CCol>
      </CRow>
    </div>
  )
}

DashboardHeader.propTypes = {
  providerName: PropTypes.any,
}

export default DashboardHeader
